import type { Patient } from "@src/packages/patients/patients.types";
import { getNextMedicalHistorySection } from "./sectionRegistry";

/**
 * Get the next visible section in Medical History order.
 * AMAB patients skip AFAB-only sections such as menstrual health and pregnancies.
 */
export function getNextSection(
  currentSectionKey: string,
  patient?: Patient | null,
): { key: string; route: string; label: string } | null {
  const next = getNextMedicalHistorySection(currentSectionKey, patient);
  if (!next) return null;

  return {
    key: next.key,
    route: next.route,
    label: next.titleKey,
  };
}
